module.exports = __webpack_public_path__ + "public-ui/img/file.404b73a8.svg";